import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import ConfigContext from "../../common/context/ConfigContext";
import { STORE_POLICY } from "../../common/constants";

export default function StorePolicy(props) {
  const siteConfig = useContext(ConfigContext);

  const storePolicy = siteConfig.policy || STORE_POLICY;

  return (
    <Box py={2}>
      <Typography
        dangerouslySetInnerHTML={{
          __html: storePolicy,
        }}
      ></Typography>
    </Box>
  );
}
